import { FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class OutsideClickErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      // Check if the control is touched and its value is empty
      const isControlInvalid = control && control.invalid && (form && form.submitted);
      return !!(isControlInvalid);
    }
  }